module.exports = __webpack_public_path__ + "img/logo_xl.5ac43f90.png";